import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints'

const breakpoints = createBreakpoints({})
// Create a theme instance.
const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Montserrat, sans-serif',
    ].join(','),
    h1:{
      fontSize: "1.125rem",
      color :"#192A7F",
      letterSpacing: 0,
      fontWeight:"bold",
      lineHeight:"1.375rem",
      [breakpoints.up('sm')]:{
        fontSize: "2.098rem",
        lineHeight:"2.261rem",
      }
    },
    h2:{
      fontSize: "1.5rem",
      color :"#192A7F",
      letterSpacing: 0,
      fontWeight:"bold",
      lineHeight:"1.813rem",
      [breakpoints.up('sm')]:{
        fontSize: "2.098rem",
        lineHeight:"2.261rem",
      }
    },
  },
  palette: {
    primary: {
      main: '#192A7F',
    },
    secondary: {
      main: '#2196C0',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
  overrides: { 
    datePicker: {
      color: "#2196C0",
      selectColor: "#2196C0",
    },
  },
});

export default function AppTheme({ children }) {
    return (
          <MuiThemeProvider theme={theme}>
              {children}
          </MuiThemeProvider>
      );
}
export {
  theme,
}